// extracted by mini-css-extract-plugin
export var createdDate = "_n7-1";
export var divider = "_n7-2";
export var headerDivider = "_n7-3";
export var messagesCard = "_n7-0";
export var messagesContainer = "_n7-6";
export var messagesContainerWrapper = "_n7-4";
export var showLeftPanelButton = "_n7-8";
export var topButtons = "_n7-7";
export var withPadding = "_n7-5";